import { render, staticRenderFns } from "./EvolutionTab.vue?vue&type=template&id=bd2e85d0"
import script from "./EvolutionTab.vue?vue&type=script&setup=true&lang=js"
export * from "./EvolutionTab.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports